import React from "react";
import ReimbursementsPage from "components/common/reimbursements/ReimbursementsPage";

const EmployeeReimbursements: React.FC = () => <ReimbursementsPage mine />;

export default EmployeeReimbursements;
